import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

type PlantPoint = { x: number; y: number; custom?: unknown };
type PlantSeries = { data?: unknown[]; name?: string; color?: string };

const isPlantPoint = (p: unknown): p is PlantPoint => (
  typeof p === 'object' && p !== null
  && typeof (p as PlantPoint).x === 'number'
  && typeof (p as PlantPoint).y === 'number'
);

const calculateDailyMaxPlant = (series: PlantSeries[]) => series.map((s) => {
  const dailyMax: Record<string, PlantPoint> = {};

  (s.data || []).forEach((point) => {
    if (!isPlantPoint(point)) return;
    const day = dayjs.utc(point.x).format('YYYY-MM-DD');
    if (dailyMax[day] === undefined || point.y > dailyMax[day].y) {
      dailyMax[day] = point;
    }
  });

  const maxData = Object.keys(dailyMax)
    .sort()
    .map((day) => dailyMax[day]);

  return {
    name: `Máximo diario${s.name ? ` - ${s.name}` : ''}`,
    type: 'spline',
    data: maxData,
    color: s.color || '#FF6600',
    lineWidth: 2,
    marker: {
      enabled: true,
      radius: 4,
    },
    dashStyle: 'ShortDash',
  };
});

export default calculateDailyMaxPlant;
